import { useEffect } from 'react';
import { useThemeStore } from '@/store/theme/store';
import { ToastContainer } from 'react-toastify';

export default function ThemeWrapper({ children }: { children: React.ReactNode }) {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    document.documentElement.classList.toggle('light-theme', theme === 'light');
  }, [theme]);

  return (
    <>
      {children}
      <ToastContainer theme={theme} autoClose={30000} />
    </>
  );
}
